import {
  Modal,
  ModalContent,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ImportFromInstagramForm } from "../Forms";
import GenerateRecipeFromTextForm from "../Forms/GenerateRecipeFromTextForm/GenerateRecipeFromTextForm";
import ImageOCRChatgptVision from "../Forms/ImageOCRChatgptVision";
import ImageOCRForm from "../Forms/ImageOCRForm/ImageOCRForm";

type Props = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle?: () => void;
  onCancel?: () => void;
  onSubmit: () => void;
};

type SelectionOptions =
  | "InstagramURL"
  | "ExtractRecipeFromImage"
  | "ExtractRecipeFromImageChatGPTVision"
  | "GenerateRecipeFromText";
const ImportFromInstagramModal = ({
  isOpen,
  onClose,
  onOpen,
  onCancel,
  onSubmit,
}: Props) => {
  const [selection, setSelection] = useState<SelectionOptions>("InstagramURL");
  const cancelRef = React.useRef() as any;
  return (
    <>
      <Modal size={"xl"} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay>
          <ModalContent>
            <Text
              fontSize={20}
              paddingLeft={5}
              paddingRight={5}
              paddingTop={2}
              fontWeight={"bold"}
            >
              Generate Recipes Automatically
            </Text>

            <RadioGroup
              colorScheme={"brand"}
              onChange={(e) => setSelection(e as SelectionOptions)}
              value={selection}
            >
              <Stack direction="column" p={4}>
                <Radio value="InstagramURL">Instagram URL</Radio>
                <Radio value="ExtractRecipeFromImage">
                  Extract recipe from image
                </Radio>

                <Radio value="ExtractRecipeFromImageChatGPTVision">
                  Extract recipe from images using ChatGPT Vision
                </Radio>

                <Radio value="GenerateRecipeFromText">
                  Generate Recipe From Text
                </Radio>
              </Stack>
            </RadioGroup>
            {selection === "InstagramURL" && (
              <ImportFromInstagramForm
                onBack={() => {
                  onClose();
                  onCancel && onCancel();
                }}
                onSave={() => {
                  onClose();
                  onSubmit();
                }}
              />
            )}
            {selection === "ExtractRecipeFromImage" && <ImageOCRForm />}
            {selection === "ExtractRecipeFromImageChatGPTVision" && (
              <ImageOCRChatgptVision />
            )}

            {selection === "GenerateRecipeFromText" && (
              <GenerateRecipeFromTextForm />
            )}
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
};

export default ImportFromInstagramModal;
